<template>
  <div class="common-words">
    <el-row type="flex" style="margin-bottom: 10px;">
      <el-button type="primary" @click="openDialog('add')">新增</el-button>
      <div style="margin: 0 10px;">
        <el-input v-model="typeName" placeholder="输入类型名称"></el-input>
      </div>
      <el-button type="primary" @click="searchTable">搜索</el-button>
    </el-row>
    <el-table border :header-cell-style="{ textAlign: 'center' }" :data="listTable" v-loading="loadingTable">
      <el-table-column prop="typeName" label="类型名称" align="center"></el-table-column>
      <el-table-column prop="content" label="内容" align="center"></el-table-column>
      <el-table-column prop="exceptionTypeName" label="异常类型" align="center" width="200"></el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <template slot-scope="scope">
          <el-button type="primary" @click="openDialog('edit', scope.row)">编辑</el-button>
          <el-button type="danger" @click="deleteWorkOrder(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50, 100, 200, 400]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="closeDialog">
      <el-form label-width="100px">
        <el-form-item label="类型类型">
          <el-select v-model="formData.exceptionType" clearable >
            <el-option v-for="item in exceptionTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型名称">
          <el-input type="textarea" :autosize="{ minRows: 2 }" v-model="formData.typeName"></el-input>
        </el-form-item>
        <el-form-item label="类型内容">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="formData.content"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="confirmWorkOrder" :loading="loadingConfirm">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api';

export default {
  name: "AbnormalWords",
  data() {
    return {
      page: 1,
      size: 20,
      total: 0,
      typeName: '',
      listTable: [],
      loadingTable: false,
      dialogTitle: '',
      dialogVisible: false,
      formData: {
        exceptionType: '',
        typeName: '',
        content: '',
      },
      loadingConfirm: false,
      exceptionTypeOptions: [
        {
          label: '缺件',
          value: 1
        },
        {
          label: '图货不符',
          value: 2
        },
        {
          label: '破损',
          value: 3
        },
        {
          label: '等件',
          value: 4
        },
        {
          label: '多件',
          value: 5
        },
        {
          label: '其他',
          value: 6
        }
      ]
    }
  },
  created() {
    this.getTable()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getTable()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getTable()
    },
    searchTable() {
      this.page = 1
      this.getTable()
    },
    getTable() {
      const API = Baseurl + 'abnormalCommonWordController/selectAbnormalCommonWords'
      const paramsData = {
        page: this.page,
        size: this.size,
        typeName: this.typeName,
      }
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data
        if (code === 200) {
          data.list.map(item => {
            this.$set(item, 'exceptionTypeName', '')
            if (item.exceptionType) {
              item.exceptionTypeName = this.exceptionTypeOptions.filter(x => x.value == item.exceptionType)[0].label
            }
          })
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    openDialog(type, row) {
      if (type === 'add') {
        this.dialogTitle = '新增异常常用语'
      } else if (type === 'edit') {
        this.dialogTitle = '编辑异常常用语'
        this.formData.id = row.id
        this.formData.typeName = row.typeName
        this.formData.content = row.content
        this.formData.exceptionType = row.exceptionType
      }
      this.dialogVisible = true
    },
    closeDialog() {
      this.formData = this.$options.data().formData
    },
    confirmWorkOrder() {
      if (!this.formData.content) {
        this.$message.warning('请确认是否输入内容')
        return
      }
      let API = Baseurl + 'abnormalCommonWordController/insertAbnormalCommonWord'
      const paramsData = this.formData

      if (this.dialogTitle === '编辑异常常用语') {
        API = Baseurl + 'abnormalCommonWordController/updateAbnormalCommonWord'
      }
      this.loadingConfirm = true
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.dialogVisible = false
          this.loadingConfirm = false
          this.getTable()
          this.$message.success('操作成功')
        } else {
          this.$message.error(data)
        }
      })
    },
    deleteWorkOrder(row) {
      this.$confirm('确定要删除该项吗', '提示').then(() => {
        const API = Baseurl + 'abnormalCommonWordController/deleteAbnormalCommonWord'
        const paramsData = { id: row.id }

        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          if (code === 200) {
            this.getTable()
            this.$message.success('操作成功')
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.common-words {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
</style>
